import ErrorIcon from '@mui/icons-material/Error';
import { Box, Button, Checkbox, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import TermsDialog from 'commons/TermsDialogy';
import Text from 'commons/Text';
import Routes from 'utils/Route';

import useStyles from './styles';

const GroupButtonBottomCertificate = ({ onSubmit }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.account.user);
  const [agree, setAgree] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);

  const handleCancel = () => {
    navigate(Routes.GalleryDetail(user?.uuid));
  };

  return (
    <Box className={classes.boxButtonBottom}>
      <div className={classes.wrapTextImportant}>
        <ErrorIcon />
        <Text
          className={classes.textImportant}
          type="md"
        >
          {t('the_information_in_the_certificate')}
        </Text>
      </div>

      <div style={{ marginLeft: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={agree}
              onChange={(e) => setAgree(e.target.checked)}
              color="primary"
            />
          }
          label={
            <Text variant="span">
              {t('i_have_read_and_agree_to')} {''}
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTerms(true);
                }}
                href="/terms-and-conditions"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'underline', fontWeight: 500 }}
              >
                {t('gladius_art_terms_conditions')}
              </a>
              .
            </Text>
          }
          className={classes.checkboxAgreement}
        />
      </div>

      <div className={classes.groupButton}>
        <Button
          variant="outlined"
          className={classes.buttonCancel}
          onClick={handleCancel}
        >
          <Text
            className={classes.textButton}
            variant="span"
          >
            {t('cancel')}
          </Text>
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          className={classes.buttonNext}
          disabled={!agree}
        >
          <Text
            className={classes.textButton}
            variant="span"
          >
            {t('validate')}
          </Text>
        </Button>
      </div>
      <TermsDialog
        open={openTerms}
        onClose={() => setOpenTerms(false)}
      />
    </Box>
  );
};

export default GroupButtonBottomCertificate;
